import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ADMIN_GENERAL_SETTINGS_ROUTE_NAME } from '@modules/general-settings/constants';
import {
  AdminGeneralSettingsTableColumnsEditModule,
} from '@modules/general-settings/submodules/table-columns-settings/submodules/edit/AdminGeneralSettingsTableColumnsEditModule';
import { useI18n } from '@modules/i18n/composables';

import {
  ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_MAIN_ROUTE_NAME,
  ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_PERMISSIONS,
  ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_TREE_ROUTE_NAME,
  TRANSLATION_GROUP_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS,
} from './constants';
import { getTranslationKeys } from './translations';

export class AdminGeneralSettingsTableColumnsSettingsModule extends AppModule {
  protected submodules: AppModule[] = [
    new AdminGeneralSettingsTableColumnsEditModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      name: ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_MAIN_ROUTE_NAME,
      path: 'table-columns-settings',
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      permission: ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_PERMISSIONS.SHOW,
      redirect: {
        name: ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_TREE_ROUTE_NAME,
      },
      keepAliveInclude: 'AdminGeneralSettingsTablesTreePage',
    });

    router.addChildRoute(ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_MAIN_ROUTE_NAME, {
      name: ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_TREE_ROUTE_NAME,
      path: '',
      component: () => import('./pages/AdminGeneralSettingsTablesTreePage/AdminGeneralSettingsTablesTreePage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      caption: getTPath(TRANSLATION_GROUP_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS, 'TAB_NAME'),
      to: {
        name: ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_MAIN_ROUTE_NAME,
      },
      permission: ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_PERMISSIONS.SHOW,
      id: ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_MAIN_ROUTE_NAME,
      order: 70,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS, getTranslationKeys);
  }
}
